/** Relative "time ago" formatting for timestamps in tables. */
export function timeAgo(iso: string | null | undefined): string {
  if (!iso) return "never";
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  const s = Math.round(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}

/** Human-readable byte count (e.g. blob/replay storage). 1024-based, ~3 significant digits. */
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  const units = ["KiB", "MiB", "GiB", "TiB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v >= 100 ? Math.round(v) : v.toFixed(1)} ${units[i]}`;
}

export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

/** Friendly label for a board-group window name (Phase 11.4). */
export function windowLabel(w: string): string {
  const known: Record<string, string> = {
    all_time: "All-time",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    rolling_24h: "Rolling 24h",
    rolling_7d: "Rolling 7d",
    rolling_30d: "Rolling 30d",
  };
  return known[w] ?? w;
}
